<template>
  <component
    :is="getContainerType"
    v-if="shouldRenderConfig"
    :class="getClassName"
  >
    <appSelectOption
      v-for="(option, key) in getOtherOptions"
      :key="key"
      :propsData="option"
      :selectId="'others_select' + key"
      :optionType="optionsType"
    ></appSelectOption>
  </component>
</template>
<script>
import { useWebproductStore } from "@/stores/modules/webproduct";
import { mapState, mapActions } from "pinia";

export default {
  computed: {
    ...mapState(useWebproductStore, ["getOtherOptions"]),
    optionsType: () => {
      return "other";
    }
  },
  props: ["hideContainer"]
};
</script>
